export default __webpack_public_path__ + "static/media/fumbled-ball.a83c0085.jpg";